import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** Errors raised by the orqestrator client. */

/**
 * A chat turn failed. Carries the HTTP status and a truncated response body,
 * because the two questions asked of a failed run are always "was it auth or
 * the agent?" and "what did the server actually say?".
 */
export var OrqChatError = /*#__PURE__*/function (_Error) {
  function OrqChatError(message, status, body) {
    var _this;
    _classCallCheck(this, OrqChatError);
    _this = _callSuper(this, OrqChatError, [message]);
    _this.name = "OrqChatError";
    _this.status = status;
    _this.body = body;
    return _this;
  }
  _inherits(OrqChatError, _Error);
  return _createClass(OrqChatError);
}(/*#__PURE__*/_wrapNativeSuper(Error));